var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_964_176",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 51,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.000144958H50.4999V50H0.5V0.000144958Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_964_176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.8394 31.4714H2.79492C1.93193 31.4714 1.23242 30.7719 1.23242 29.9089V20.0913C1.23242 19.2283 1.93193 18.5288 2.79492 18.5288H48.2049C49.0679 18.5288 49.7674 19.2283 49.7674 20.0913V29.9089C49.7674 30.7719 49.0679 31.4714 48.2049 31.4714H39.2573",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6167 28.2358L30.0467 21.8556C30.0964 21.7342 30.2682 21.7341 30.3181 21.8553L32.726 28.2358",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3746 26.6468H31.9805",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5653 21.7939H42.8634V28.2062H45.5653",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.366 25.0001H42.8634",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0664 21.8667V28.038",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.381 25.0001C24.381 26.7304 23.4207 28.0996 21.897 28.1262C21.3898 28.1351 20.0791 28.14 20.0791 28.14C20.0791 28.14 20.0709 25.8653 20.0709 24.9932C20.0709 24.2768 20.0664 21.8602 20.0664 21.8602H21.845C23.5162 21.8602 24.381 23.2697 24.381 25.0001Z",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43457 21.7644V26.2175C5.43457 26.9758 5.81074 27.4863 6.4498 27.8945C6.76103 28.0935 7.154 28.2351 7.64257 28.2358C8.06562 28.2363 8.41923 28.1384 8.71161 27.9912C9.45634 27.6161 9.93124 27.0466 9.93124 26.2128V21.7644",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9617 21.7644H39.5355",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7415 21.971V28.2357",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1669 21.7644V28.2358",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8307 23.5906C16.8307 24.5992 15.9774 25.4168 14.9688 25.4168C14.4686 25.4168 13.1793 25.4249 13.1793 25.4249C13.1793 25.4249 13.1712 24.099 13.1712 23.5906C13.1712 23.1731 13.1667 21.7644 13.1667 21.7644H14.9688C15.9774 21.7644 16.8307 22.582 16.8307 23.5906Z",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9517 18.7429C48.1373 15.6838 46.7409 12.8619 44.8874 10.4039C44.7654 10.2421 44.7792 10.0159 44.9224 9.87257L45.8784 8.91662C46.114 8.68098 45.9795 8.27736 45.6497 8.23029L39.5102 7.35315C38.9764 7.27688 38.5188 7.73449 38.595 8.26838L39.4721 14.4077C39.5192 14.7377 39.9228 14.8722 40.1586 14.6365L40.8691 13.9259C40.9111 13.8839 40.9618 13.8517 41.0176 13.8315C41.0735 13.8113 41.1331 13.8036 41.1922 13.809C41.2513 13.8143 41.3085 13.8326 41.3598 13.8625C41.4111 13.8925 41.4552 13.9333 41.4889 13.9821C42.4603 15.3885 43.2411 16.9174 43.811 18.5288",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38489 42.2034C12.6984 46.4948 18.616 49.1755 25.1598 49.2652C36.4802 49.4208 46.1388 41.7243 48.945 31.2614",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8004 31.4714C41.1718 38.8541 34.1864 44.2377 25.9216 44.4129C20.5138 44.5275 15.5962 42.43 12.0094 38.9641",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.19946 18.5287C9.82817 11.1459 16.8138 5.76222 25.0788 5.58722C30.4864 5.47267 35.4037 7.57022 38.9904 11.036",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.37064 8.9044C4.89526 11.687 3.04702 15.0399 2.05493 18.7386",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6149 7.79669C38.3015 3.5053 32.3837 0.824739 25.8399 0.734896C19.7419 0.651107 14.1261 2.84583 9.80383 6.52404",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.04858 31.2577C2.89428 34.4337 4.36703 37.3543 6.32758 39.8774L5.12143 41.0835C4.88578 41.3192 5.02025 41.7228 5.35023 41.7699L11.4896 42.647C12.0235 42.7232 12.481 42.2657 12.4048 41.7318L11.5277 35.5924C11.4806 35.2625 11.077 35.128 10.8413 35.3636L10.1307 36.0743C10.0887 36.1162 10.038 36.1485 9.98217 36.1687C9.92635 36.1889 9.86677 36.1966 9.80764 36.1912C9.74851 36.1859 9.69128 36.1676 9.64 36.1377C9.58872 36.1078 9.54463 36.067 9.51087 36.0181C8.53954 34.6117 7.75873 33.0828 7.1888 31.4714",
    stroke: "#0D8B5A",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/update.530b8d9c0763caceef8ddac7c670a100.svg";
export { ForwardRef as ReactComponent };